<template>
    <v-layout class="header-menu" row>
        <v-flex xs8 class="hotel-name locations-group-row d-inline-flex">
            <BottomSheetHome
                v-if="roomList"
                ref="BottomSheet"
                :activeGroup="roomList.indexOf(selectedRoom)"
                :locations="roomList"
                @setRoom="setRoom"
                @updateHomeList="getHomes"
            />
            <v-btn
                class="locations-group__btn locations-group__btn-active mx-1"
                :input-value="true"
                depressed
                rounded
                @click="openSheet"
            >
                {{selectedRoom.name}}
                <div
                    v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                    class="d-inline-flex"
                />
            </v-btn>
        </v-flex>
        <v-flex class="dashboard">
            <div
                v-if="editMode"
                class="dashboard__icon cursor-pointer"
                @click="$emit('add-modal')"
            >
                <div
                    v-html="require('!html-loader!@/assets/icons/close_icon.svg')"
                    class="rotate-45"
                />
            </div>
            <div
                v-if="editMode"
                class="dashboard__icon cursor-pointer"
                @click="switchEdit"
            >
                <div v-html="require('!html-loader!@/assets/icons/settings_active.svg')" />
            </div>
            <div
                v-else
                class="dashboard__icon cursor-pointer"
                @click="switchEdit"
            >
                <div v-html="require('!html-loader!@/assets/icons/settings.svg')" />
            </div>
            <div
                class="dashboard__icon cursor-pointer"
                @click="openModalChangeTheme"
            >
                <div v-html="require('!html-loader!@/assets/icons/color.svg')" />
            </div>
            <div
                class="dashboard__icon cursor-pointer"
                @click="confirmLogout"
            >
                <div v-html="require('!html-loader!@/assets/icons/logout.svg')" />
            </div>
        </v-flex>
        <ModalMessage
            v-model="modalConfirmLogoutOpen"
            title="Выход из профиля"
            text="Вы точно хотите выйти из профиля?"
            text-btn="Отменить"
            text-confirm-btn="Выйти"
            show-confirm-btn
            text-center
            @confirm="logout"
        />
        <ModalChangeTheme
            v-if="modalChangeTheme"
            v-model="modalChangeTheme"
        />
    </v-layout>
</template>

<script>
import ModalChangeTheme from "@/components/modals/ModalChangeTheme";
import ModalMessage from "@/components/modals/ModalMessage";
import BottomSheetHome from "@/components/BottomSheetHome.vue";

export default {
    name: "HomeTitle",
    components: {ModalChangeTheme, ModalMessage, BottomSheetHome},
    props: {
        value: {
            type: Object,
        },
    },
    data() {
        return {
            selectedRoom: {},
            roomList: [],
            editMode: false,
            modalConfirmLogoutOpen: false,
            modalChangeTheme: false,
        };
    },
    mounted() {
        this.getHomes();
    },
    methods: {
        openSheet() {
            this.$refs.BottomSheet.open();
        },
        setRoom(room) {
            this.selectedRoom = room;
            if (room) {
                this.$emit("input", room);
                this.$store.commit('setHome', room);
            } else {
                this.$store.commit('setHome', {});
            }
        },
        switchEdit() {
            this.editMode = !this.editMode;
            this.$store.commit('setEditMode', this.editMode);
        },
        confirmLogout() {
            this.modalConfirmLogoutOpen = true;
        },
        logout() {
            localStorage.removeItem("RobohomeDataAccessToken");
            this.$router.go( 0);
        },
        getHomes() {
            this.$http.get('/homes/home/homes/')
                .then((res) => {
                    this.roomList = res.data.results;
                    if (this.$store.getters.home) {
                        if (this.$store.getters.home.uid) {
                            this.setRoom(this.roomList.find(room => room.uid == this.$store.getters.home.uid));
                            return;
                        }
                        this.setRoom(this.roomList.find(room => room.uid == this.$store.getters.home));
                    }
                    if ((!this.selectedRoom || this.selectedRoom == -1) && this.roomList.length) {
                        this.setRoom(this.roomList[0]);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        openModalChangeTheme() {
            this.modalChangeTheme = true;
        },
    },
}
</script>

<style lang="scss">
.hotel-name {
    gap: 0;
    color: var(--rh-main-color);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

.hotel-list__list.v-list {
    background-color: var(--rh-list-background);
    min-width: 250px;

    .v-label {
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
        color: var(--rh-main-color);
    }

    .v-input--selection-controls {
        margin: 0;
        min-height: 34px;
        max-height: 34px;

        &__input {
            display: none;
        }

        .v-input__slot {
            margin: 0;
        }

        .v-list-item {
            min-height: 34px;
            max-height: 34px;

            &__content {
                padding: 0;
            }
        }
    }
}
</style>